import { useAppContext } from '@/context/app';
import { isMatchMobileMedia } from '@/util/is-match-mobile-media';
import debounce from 'lodash.debounce';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

let prevHeadStickedOnTop = true;

const HeaderRectCalculate = props => {
  const { headerToolbarRef, mobileHeaderMenuRef, headerId } = props;

  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [
    ,
    {
      actions: { toggleHeadStickedOnTop, setHeaderToolbarHeight, setHeaderHeight },
    },
  ] = useAppContext();

  useEffect(() => {
    const calculateHeaderRect = () => {
      const headerToolBarElement = headerToolbarRef.current;
      const mobileHeaderMenu = mobileHeaderMenuRef.current;
      const header = document.getElementById(headerId);

      if (headerToolBarElement) {
        setHeaderToolbarHeight(
          headerToolBarElement.offsetHeight - (isMatchMobileMedia() ? mobileHeaderMenu?.offsetHeight || 0 : 0) || 0,
        );
      }

      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    calculateHeaderRect();

    const resizeHandler = debounce(() => calculateHeaderRect, 500);

    window.addEventListener('resize', resizeHandler);

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [
    setHeaderToolbarHeight,
    pathname,
    searchParams,
    setHeaderHeight,
    headerId,
    headerToolbarRef,
    mobileHeaderMenuRef,
  ]);

  useEffect(() => {
    const isStickedOnTop = window.scrollY === 0;

    if (prevHeadStickedOnTop === isStickedOnTop) return;

    toggleHeadStickedOnTop(isStickedOnTop);
    prevHeadStickedOnTop = isStickedOnTop;
  }, [pathname, searchParams, toggleHeadStickedOnTop]);

  useEffect(() => {
    const scrollHandler = () => {
      const isStickedOnTop = window.scrollY === 0;

      if (prevHeadStickedOnTop === isStickedOnTop) return;

      toggleHeadStickedOnTop(isStickedOnTop);
      prevHeadStickedOnTop = isStickedOnTop;
    };

    document.addEventListener('scroll', scrollHandler);

    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, [toggleHeadStickedOnTop]);

  return null;
};

export default HeaderRectCalculate;
